import * as Yup from 'yup';

const validationSchema = Yup.object().shape({
  mail_to: Yup.string()
    .required('Email is required')
    .test('is-valid-email', 'Invalid email format', function (value) {
      if (!value) return false;
      const parts = value.split('@');
      if (parts.length !== 2) return false;
      const domain = parts[1];
      return domain.includes('.') && domain.split('.').every(p => p.length > 0);
    }),
});

export const ValidateEmail = async (email) => {
  try {
    await validationSchema.validate({ mail_to: email });
    //console.log('Email is valid:', email);
    return true;
  } catch (err) {
   // console.log('Email validation error:', err.message);
    return false;
  }
};
  
  export const ScrollToViewFirstError = (newErrors) => {
    
    if (Object.keys(newErrors).length !== 0) {
      const errorField = Object.keys(newErrors)[0];
      const errorElement = document.getElementById(errorField);
      if (errorElement) {
          const elementPosition = errorElement.getBoundingClientRect().top + window.pageYOffset;
          const offset = 100; 
        window.scrollTo({
          top: elementPosition - offset,
          behavior: 'auto'
        });
      }
    }
  }

  export const DateConvert = (dateString) => {
    if (!dateString) return '';
    const date = new Date(dateString);
    const day = String(date.getDate()).padStart(2, '0');
    const month = String(date.getMonth() + 1).padStart(2, '0'); // Months are 0-based
    const year = date.getFullYear();
    return `${day}/${month}/${year}`;
  }

  export const DateConvertWithTime = (dateString) => {
  if (!dateString) return '';

  const date = new Date(dateString);

  const day = String(date.getDate()).padStart(2, '0');
  const month = String(date.getMonth() + 1).padStart(2, '0'); // Months are 0-based
  const year = date.getFullYear();

  const hours = String(date.getHours()).padStart(2, '0');
  const minutes = String(date.getMinutes()).padStart(2, '0');
  const seconds = String(date.getSeconds()).padStart(2, '0');
  return `${day}/${month}/${year} ${hours}:${minutes}:${seconds}`;
};

export const StripHtmlAndTruncate = (text, wordLimit = 55) => {
  if (!text) return { truncated: "", isTruncated: false, fullText: "" };

  // Strip HTML tags and replace common entities
  const strippedText = text.replace(/<[^>]*>?/gm, '').replace(/&nbsp;/g, ' ').replace(/_/g, ' ');

  const words = strippedText.split(/\s+/).filter(Boolean);
  if (words.length > wordLimit) {
    return {
      truncated: words.slice(0, wordLimit).join(' ') + '...',
      isTruncated: true,
      fullText: strippedText
    };
  }

  return {
    truncated: strippedText,
    isTruncated: false,
    fullText: strippedText
  };
};

export const floorTo = (num, decimals = 2) => {
  if (num === null || num === undefined || isNaN(num)) return 0;

  const factor = 10 ** decimals;
  return Math.floor((Number(num) + Number.EPSILON) * factor) / factor;
};

export const cleanHtmlEntities = (text) => {
  if (!text) return '';

  const replacements = {
    '&nbsp;': ' ',     // non-breaking space → normal space
    '&amp;': '&',      // ampersand
    '&lt;': '<',       // less than
    '&gt;': '>',       // greater than
    '&quot;': '"',     // double quote
    '&#39;': "'",      // single quote
    '&ndash;': '-',    // en-dash → &
    '&mdash;': '—',    // em-dash → &
    '&hellip;': '...', // ellipsis
    '&apos;': "'",     // apostrophe
    '&amp;': '&',      // ampersand
  };

  let cleaned = text;
  for (const [entity, char] of Object.entries(replacements)) {
    const regex = new RegExp(entity, 'g');
    cleaned = cleaned?.replace(regex, char);
  }
  cleaned = cleaned?.replace(/[–—]/g, '&');
  return cleaned?.replace(/\s+/g, ' ').trim();
}

// export const roundNumber = (val) => {
//   return Math.round(Number(val));
// };

export const roundNumber = (val) => {
  const number = Number(val);

  if (!Number.isFinite(number)) {
    return 0;
  }

  const decimal = number % 1;

  return decimal > 0.5 ? Math.ceil(number) : Math.floor(number);
};

// datatable sort helpers ---------------------------------------------------

// case-insensitive text compare so "apple" and "Apple" sort together
export const compareText = (a, b) =>
  String(a ?? "")
    .trim()
    .toLowerCase()
    .localeCompare(String(b ?? "").trim().toLowerCase());

// decimal columns come back as strings from the API, so compare them numerically
export const compareNumber = (a, b) => {
  const numA = Number(a);
  const numB = Number(b);
  return (
    (Number.isFinite(numA) ? numA : 0) - (Number.isFinite(numB) ? numB : 0)
  );
};

// "Sea, Air" is stored in the order it was picked, so split it into a clean,
// alphabetically ordered list before it is either rendered or sorted
export const applicableList = (value) => {
  const items = String(value ?? "")
    .split(",")
    .map((item) => item.trim())
    .filter((item) => item);

  // a value can be saved twice, which would hand React duplicate keys
  return [...new Set(items)].sort((a, b) => compareText(a, b));
};

// export const formatOrdinalDate = (value) => {
//   console.log(value);
//   if ([null, undefined, ""].includes(value)) return "";
//   const date = new Date(value);
//   if (isNaN(date.getTime())) return "";

//   const day = date.getDate();
//   const month = date.toLocaleString("en-GB", { month: "short" });
//   const year = date.getFullYear();

//   const suffix =
//     day % 10 === 1 && day !== 11 ? "st" :
//       day % 10 === 2 && day !== 12 ? "nd" :
//         day % 10 === 3 && day !== 13 ? "rd" : "th";

//   return `${day}${suffix} ${month} ${year}`;
// };
export const formatOrdinalDate = (value) => {
  if ([null, undefined, ""].includes(value)) return "";

  const date = new Date(value);
  if (isNaN(date.getTime())) return "";

  const day = date.getUTCDate();
  const month = date.toLocaleString("en-GB", {
    month: "short",
    timeZone: "UTC",
  });
  const year = date.getUTCFullYear();

  const suffix =
    day % 10 === 1 && day !== 11 ? "st" :
    day % 10 === 2 && day !== 12 ? "nd" :
    day % 10 === 3 && day !== 13 ? "rd" :
    "th";

  return `${day}${suffix} ${month} ${year}`;
};

export const getPaymentTermFrequency = (paymentTerm) => {
  return {
    monthly_dd: "Monthly",
    manual_payment_monthly: "Monthly",
    quarterly_dd: "Quarterly",
    manual_payment_quarterly: "Quarterly",
    "100_upfront": "Yearly",
    "100_post_completion": "Yearly",
    "50_upfront": "Half-Yearly",
  }[paymentTerm] || "Monthly";
};

export const getPriceChange = (oldValue, newValue, decimals = 1) => {
  const oldVal = Number(oldValue);
  const newVal = Number(newValue);

  if (isNaN(oldVal) || isNaN(newVal) || oldVal === 0) return null;

  const diff = newVal - oldVal;
  const percent = Math.abs((diff / oldVal) * 100).toFixed(decimals);

  // percent 0.0 par aaye to koi change nahi dikhana
  if (Number(percent) === 0) return null;

  return {
    percent,
    diff,
    isIncrease: diff > 0,
    arrow: diff > 0 ? "↑" : "↓",
    label: `${diff > 0 ? "↑" : "↓"} ${percent}%`,
  };
};





